import { render, staticRenderFns } from "./DocumentOutlineIcon.vue?vue&type=template&id=2268f41a&scoped=true"
import script from "./DocumentOutlineIcon.vue?vue&type=script&lang=ts"
export * from "./DocumentOutlineIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268f41a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2268f41a')) {
      api.createRecord('2268f41a', component.options)
    } else {
      api.reload('2268f41a', component.options)
    }
    module.hot.accept("./DocumentOutlineIcon.vue?vue&type=template&id=2268f41a&scoped=true", function () {
      api.rerender('2268f41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/DocumentOutlineIcon.vue"
export default component.exports